import type { SubjectActivityAuthor } from '@/lib/apollo/query/getSubjectChangeActivities/dataTransformations'

export const formatAuthorLabel = (author: SubjectActivityAuthor): string => {
  const parts = [author.type]

  const identifier = author.name ?? author.id
  if (identifier) {
    parts.push(identifier)
  }

  if (author.email) {
    parts.push(author.email)
  }

  return parts.join(' | ')
}
